module.exports = __webpack_public_path__ + "static/img/icon-mall-alipay.37541d7c.png";